import React, { ReactNode, FC } from 'react'
import classNames from 'classnames'
import { Box, makeStyles, Typography, BoxProps, createStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

interface IOnboardingStepContainerProps {
  children: ReactNode
  title?: ReactNode
  subtitle?: ReactNode
  /**
   * @default 'center'
   */
  textAlign?: BoxProps['textAlign']
  /**
   * @default 647
   */
  maxWidth?: number
  /**
   * @default false
   */
  fadeIn?: boolean
}

type TClassKey = 'root' | 'subtitle'

const useOnboardingStepContainerStyles = makeStyles(theme =>
  createStyles<TClassKey, Pick<IOnboardingStepContainerProps, 'maxWidth'>>({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(3),
      margin: '0 auto',

      // Add more padding on desktop
      [theme.breakpoints.up('md')]: {
        maxWidth: props => props.maxWidth,
        paddingTop: theme.spacing(9),
      },
    },
    subtitle: {
      marginTop: theme.spacing(1),
      color: brandColors.coolGray5,
    },
  })
)

/**
 * Helper display component to style each step in onboarding
 */
export const OnboardingStepContainer: FC<IOnboardingStepContainerProps> = ({
  children,
  fadeIn,
  maxWidth = 647,
  subtitle,
  textAlign = 'center',
  title,
}) => {
  const classes = useOnboardingStepContainerStyles({
    maxWidth,
  })
  return (
    <Box
      className={classNames(classes.root, {
        fadeInUp: fadeIn,
      })}>
      <Box textAlign={textAlign}>
        {title && (
          <Typography variant='h3' component='div'>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant='subtitle1' component='div' className={classes.subtitle}>
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box mt={2}>{children}</Box>
    </Box>
  )
}
